import { IProfessionalSchedulesAvailable } from "../api/getProfessionals";
import { transformDateToType } from "./date-util/dateUtils";

const getSchedulesOfTime = (timeToCompare: string, availableTimes: IProfessionalSchedulesAvailable[]) => {
	const dateTimeToCompare = transformDateToType(timeToCompare);
	const schedules: IProfessionalSchedulesAvailable[] = [];

	availableTimes.forEach(time => {
		const dateTime = transformDateToType(time.horarioInicial);

		if (dateTimeToCompare.equals(dateTime)) {
			schedules.push(time);
		}
	});

	return schedules;
};
export default getSchedulesOfTime;
